import * as actionTypes from '../actionTypes/modal.actionTypes'

export function openSearchAvailableRooms() {
  return ({type: actionTypes.OPEN_SEARCH_AVAILABLE_ROOMS_MODAL})
}

export function closeSearchAvailableRooms() {
  return ({type: actionTypes.CLOSE_SEARCH_AVAILABLE_ROOMS_MODAL})
}